import { useEffect, useState } from 'react'
import { STORAGE_DATA } from '@/constants/storageData'
import { useAppSelector } from '@/redux/hooks'

const useSearchHistory = () => {
  const isServer = typeof window === 'undefined'
  const memberInfoId = useAppSelector((state) => state.member?.memberData?.memberInfoId)
  const [historyLocalStorage, setHistoryLocalStorageState] = useState<string[]>([])

  // 依登入身份區分搜尋紀錄的 key，避免同一裝置切換帳號時看到前一位使用者的紀錄
  // 訪客 = searchHistory_guest、會員 = searchHistory_{memberInfoId}
  const storageKey = `${STORAGE_DATA.SEARCH_HISTORY}_${memberInfoId || 'guest'}`

  function getHistoryLocalStorage() {
    if (!isServer) {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '[]')
      } catch (error) {
        return []
      }
    }
  }

  // 用 Effect + state 的原因是為了確保不會有 SSR 跟 CSR 資料不同造成的 hydration error
  // 依賴 storageKey，登入/登出切換身份時會重新載入對應的搜尋紀錄
  useEffect(() => {
    const historyLocalStorage: string[] = getHistoryLocalStorage() || []
    setHistoryLocalStorageState(historyLocalStorage)
  }, [storageKey])

  const setHistoryLocalStorage = (history: string) => {
    if (history.trim() !== '') {
      const nextHistory = [history, ...historyLocalStorage.filter((item) => item !== history)].slice(0, 8)
      window.localStorage.setItem(storageKey, JSON.stringify(nextHistory))
      setHistoryLocalStorageState(nextHistory)
    }
  }
  return {
    setHistoryLocalStorage,
    historyLocalStorage,
  }
}

export default useSearchHistory
